import api from './api';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ExperimentContext {
  experimentName?: string;
  partName?: string;
  courseId?: string;
  experimentId?: string;
}

interface ChatResponse {
  success: boolean;
  response: string;
  model?: string;
  provider?: string;
  usage?: { input_tokens: number; output_tokens: number };
  error?: string;
}

class AIChatService {
  async sendMessage(
    messages: ChatMessage[],
    experimentContext?: ExperimentContext
  ): Promise<ChatResponse> {
    const result = await api.post<ChatResponse>('/ai/chat', {
      messages,
      experimentContext,
    });

    if (result.success && result.data) {
      return result.data;
    }

    return {
      success: false,
      response: result.error || 'AI service unavailable. Please try again later.',
    };
  }
}

export const aiChatService = new AIChatService();
export default aiChatService;
